/**
 * Created by Mohamed on 5/12/2016.
 */
(function (TeamCommunicationAPI) {

	"use strict";
    angular.module("harriApp").directive('tsTeamWall', ["$q", "hUser", "$filter", "Upload", "TeamScheduleService", "TSUsersService", "TSMediaViewerService", "TSPullingService", "TeamCommunicationService", "hSocket", function ($q, hUser, $filter, Upload, TeamScheduleService, TSUsersService, TSMediaViewerService, TSPullingService, TeamCommunicationService, hSocket) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: "../modules/team_schedule/common/views/ts_team_wall_directive.html",
        scope: {
            brand: '='
        },
        link: function (scope, element, attrs) {

            var brandId = null;
            var financialUnitBrandId = null;

            var postWidth = $(element).find(".ts-wall").width() - 60;

            const _tcService = new TeamCommunicationService();
            let tsPullService;

            //Hold the current loggedIn User
            scope.currentUser = hUser.data.user;

            scope.team_user_id = hUser.data.user.team_user_id || hUser.data.user.id;

            // Hold the currently selected image/images to be posted

            scope.selectedFiles = [];
            scope.previewsWidth = 0;

            scope.postContent = "";
            scope.posts = scope.posts || [];

            scope.users = TSUsersService.users;
            scope.userComments = {};
            scope.loadingPosts = true;
            let events = {
                'NEWS_FEED_ADDED': (data) => {
                    getPosts(data);
                },
            };


            TSUsersService.onUsersLoaded(function() {
                scope.$digest();
            });

            const onBrandChange = TeamScheduleService.onBrandChanged((brand, newBrand) => getPosts());

            var loadUsersImages = function(brand) {
                var usersToLoad = [];

                for (var i in scope.posts) {

                    var userId = scope.posts[i].user_id;

                    scope.posts[i].fromNow = $filter("fromNow")(scope.posts[i].updated);

                    if (scope.posts[i].media.length == 1) {
                        var media = scope.posts[i].media[0];

                        var xFactor = postWidth / media.width;
                        var yFactor = 350 / media.height;

                        if (xFactor < 1 || yFactor < 1) {
                            if (xFactor < yFactor) {
                                media.viewHeight = xFactor * media.height;
                                media.viewWidth = xFactor * media.width;
                            }
                            else {
                                media.viewHeight = yFactor * media.height;
                                media.viewWidth = yFactor * media.width;
                            }
                        }
                    }

                    if (!TSUsersService.users[userId]) {
                        usersToLoad.push(userId);
                    }

                    for (var j in scope.posts[i].comments.list) {
                        var comment = scope.posts[i].comments.list[j];

                        if (!TSUsersService.users[comment.user_id]) {
                            usersToLoad.push(comment.user_id);
                        }
                    }
                }

                if (usersToLoad.length) {
                    TSUsersService.loadUsers(brand.id, usersToLoad);
                }
            };

            var onScrollHandler = function (event) {
                if ($(element).find(".ts-wall").scrollTop() + $(element).find(".ts-wall").height() >= ($(element).find(".ts-wall .wall-inner").height() - 100)) {
                    getOlderPosts();
                    $(element).find(".ts-wall").off('scroll');
                }
            };

            var getOlderPosts = function() {
                scope.loadingMorePosts = true;
                TeamScheduleService.getActiveBrand()
                    .then(function(brand) {

                        if (brand.id != brandId) {
                            brandId = brand.id;
                            scope.posts = [];
                            financialUnitBrandId = brand.financial_unit_brand_id;
                        }

                        var oldestPostId = scope.posts[scope.posts.length - 1] && scope.posts[scope.posts.length - 1].id;

                        TeamCommunicationAPI.getPosts(brand.id, oldestPostId, true)
                            .then(function(posts) {
                                scope.posts = scope.posts.concat(posts);

                                loadUsersImages(brand);
                                delete scope.loadingMorePosts;

                                scope.$digest();

                                if (posts.length) {
                                    $(element).find(".ts-wall").off('scroll').on("scroll", onScrollHandler);
                                }
                            });
                    });

                scope.$digest();
            };

            let getPosts = (data)=>  {
                TeamScheduleService.getActiveBrand()
                    .then(function(brand) {

                        if (data && !(data.brand_id === brand.id || data.top_brand_id === brand.id)) {
                            return;
                        }

                            if (brand.id != brandId) {
                            brandId = brand.id;
                            financialUnitBrandId = brand.financial_unit_brand_id;
                            scope.posts = [];
                            scope.loadingPosts = true;
                        }

                        var newestPostId = scope.posts[0] && scope.posts[0].id;

                        TeamCommunicationAPI.getPosts(brand.id, newestPostId)
                            .then(function(posts) {
                                const allPosts = posts.concat(scope.posts);

                                const uniquePostsMap = new Map();
                                for (const post of allPosts) {
                                    uniquePostsMap.set(post.id, post);
                                }
                                scope.posts = Array.from(uniquePostsMap.values());

                                delete scope.loadingPosts;

                                loadUsersImages(brand);

                                if (posts.length && newestPostId) {
                                    scope.newPosts = true;
                                }

                                $(element).find(".ts-wall").off('scroll').on("scroll", onScrollHandler);
                                scope.$digest();
                            })
                            .catch(function (err) {
                                console.error(err);

                                if (err?.data?.status_code === 403) {
                                    if(hUser.isEmployer()) {
                                        tsPullService.registerService("teamWall", null);
                                    } else {
                                        tsPullService.registerService("employeeTeamWall", null);
                                    }
                                }
                            });
                    });
            };

            let registerEvents = () => {
                for (const eventName in events) {
                    hSocket.registerEvent(eventName, events[eventName]);
                }
            };

            scope.deletePost = function(postId, index) {
                TeamCommunicationAPI.deletePost(brandId, postId)
                    .then(function() {
                        scope.posts.splice(index, 1);
                        scope.$digest();
                    });
            }

            scope.scrollToNewPosts = function() {
                scope.newPosts = false;
                $(element).find(".ts-wall").animate({"scrollTop": 0});
            }

            scope.showPostDetails = function(post, imageIndex) {
                TSMediaViewerService.showPost(post, imageIndex);
            }

            scope.addPostComment = function($event, postId) {

                if ($event) {

                    if ($event.ctrlKey) {
                        if (scope.userComments[postId] && scope.userComments[postId].content) {
                            scope.userComments[postId].content += "\r\n";
                        }
                        // If the user clicked enter while clicking Ctrl, do nothing (allow new line)
                        return;
                    }

                    $event.preventDefault();
                }

                var comment = scope.userComments[postId] && scope.userComments[postId].content;

                if (comment) {
                    comment.trim();
                    scope.userComments[postId] = scope.userComments[postId] || {};
                    scope.userComments[postId].saving = true;

                    TeamCommunicationAPI.addCommentToPost(brandId, postId, comment)
                        .then(function(commentObj) {
                            delete scope.userComments[postId];

                            for (var i in scope.posts) {
                                if (scope.posts[i].id == postId) {
                                    scope.posts[i].comments.list.splice(0, 0, commentObj);
                                    scope.$digest();
                                    break;
                                }
                            }
                        });
                }
            };

            scope.showLessComments = function (postId, index) {
                if (scope.posts[index].id == postId) {
                    scope.posts[index].comments.has_more = true;
                    scope.posts[index].comments.list.splice(3);
                }
            };

            scope.loadAllComments = function (postId, index) {
                TeamCommunicationAPI.getPostComments(brandId || brand.id, postId)
                    .then(function (comments) {
                        if (scope.posts[index].id == postId) {
                            scope.posts[index].comments.has_more = false;
                            scope.posts[index].comments.list = comments.list;
                            scope.$digest();
                        }
                    },
                    function (error) {
                        console.error(error);
                    });
            };

            scope.postToWall = function() {

                if (!scope.isUploading || scope.selectedFiles.length || scope.postContent) {

                    delete scope.error;

                    if (scope.selectedFiles.length) {
                        scope.isUploading = true;
                    }

                    var promises = {
                        brand: TeamScheduleService.getActiveBrand(),
                        token: hLoginManager.getToken(),
                    };

                    $q.all(promises)
                        .then(function(res){
                            var brand = res.brand;
                            var token = res.token;

                            Upload.upload({
                                url: TeamCommunicationAPI.getURL().replace('v1', 'v2') + 'brands/' + brand.id + '/posts',
                                withCredentials: true,
                                headers: {
                                    "Authorization": 'Bearer ' + token
                                },
                                method: "POST",
                                data: {
                                    content: scope.postContent,
                                    images: scope.selectedFiles
                                },
                                arrayKey: "[]"
                            }).progress(function (evt) {
                                var uploaded = evt.loaded || 0;
                                var total = evt.total;

                                scope.uploadProgress = 100 * uploaded/total;

                            }).success(function (data, status, headers, config) {

                                scope.selectedFiles = [];
                                scope.isUploading = false;
                                delete scope.postContent;

                                if (data && data.data && data.data.post) {
                                    var newPost = data.data.post;
                                    newPost['comments'] = { list: [] };
                                    scope.posts.splice(0, 0, newPost);
                                }

                                scope.scrollToNewPosts();

                            }).error(function (error) {
                                delete scope.isUploading;
                                scope.error = error;
                            });
                        });

                }

            }

            scope.removeFile = (event, index) => {
                event.stopPropagation();
                scope.selectedFiles.splice(index, 1);
                scope.processedFiles--;
            };

            scope.onFilesChanged = function($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
                scope.processingFiles = false;

                if ($newFiles.length) {
                    var title = $filter("translate")("Invalid files:");
                    var content = "";

                    for (var i in $newFiles) {
                        var file = $newFiles[i];

                        if (file.$error) {
                            content = content + file.name + "<br/>";
                        }
                    }

                    if (content) {
                        hAlert(title, content);
                    }
                }

            };

            scope.beforeFilesChanged = function() {
                scope.processingFiles = true;
            };

            scope.showMemberProfile = function (userId) {
                var activeBrandId = hUser.isEmployer() ? financialUnitBrandId : brandId;

                if (userId && activeBrandId) {
                    _tcService.showMemberProfile(activeBrandId, userId);
                }
            };

	        scope.$on("$destroy", function() {
                if (hUser.isEmployer()) {
                    tsPullService.registerService("teamWall", null);
                } else {
                    tsPullService.registerService("employeeTeamWall", null);
                    hSocket.close();
                }
                onBrandChange && TeamScheduleService.off(onBrandChange);
                document.body.removeEventListener('click', uploadClickHandler);
            });

            const uploadClickHandler = (event) => {
                if ($(event.target).attr('id') === `ngf-team-wall-upload-photo-action`) {
                    event.stopPropagation();
                }
            };

            const init = async () => {
                setTimeout(() => {
                    element.find('.post-text-area').focus();
                    document.body.addEventListener('click', uploadClickHandler);
                }, 10);

                if (hUser.isLoggedIn()) {
                    tsPullService = TSPullingService.init();
                    if (hUser.isEmployer()) {
                        getPosts();
                        tsPullService.registerService("teamWall", getPosts);
                    } else {
                        tsPullService.registerService("employeeTeamWall", getPosts);
                        const config = environmentsConfig.get('EmployeeAppPusherConfig');
                        await hSocket.init(config, LiveScheduleAPI.getPusherSocketAuthToken, 'private-employee-');
                        registerEvents();
                    }
                }
            };

            init();
        }
    }
}]);
})(TeamCommunicationAPI);
